import apiClient from "./client";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v1";

export async function getMyUploads() {
  return apiClient.get("/uploads/my");
}

export async function deleteUpload(id) {
  return apiClient.delete(`/uploads/${id}`);
}

export async function uploadImage(file, slug) {
  const formData = new FormData();
  formData.append("image", file);
  formData.append("slug", slug);

  const url = `${API_BASE}/uploads`;
  const headers = {};
  if (apiClient.accessToken) {
    headers["Authorization"] = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(url, {
    method: "POST",
    headers,
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    const error = new Error(data.error || "Upload failed");
    error.status = response.status;
    throw error;
  }

  return data;
}

export async function getPendingUploads() {
  return apiClient.get("/uploads/admin/pending");
}

export async function getAllUploads({ status, page = 1 } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  params.set("page", String(page));
  return apiClient.get(`/uploads/admin/all?${params.toString()}`);
}

export async function approveUpload(id) {
  return apiClient.patch(`/uploads/admin/${id}/approve`);
}

export async function rejectUpload(id, reason) {
  return apiClient.patch(`/uploads/admin/${id}/reject`, { reason });
}

export async function adminDeleteUpload(id) {
  return apiClient.delete(`/uploads/admin/${id}`);
}

export async function getAdminUploadPreviewBlobUrl(filename) {
  const headers = {};
  if (apiClient.accessToken) {
    headers.Authorization = `Bearer ${apiClient.accessToken}`;
  }

  const response = await fetch(
    `${API_BASE}/uploads/admin/preview/${encodeURIComponent(filename)}`,
    { headers }
  );

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    const error = new Error(data.error || "Failed to load preview");
    error.status = response.status;
    throw error;
  }

  const blob = await response.blob();
  return URL.createObjectURL(blob);
}
